import styled from 'styled-components';

import { ModalTitle } from 'legacyComponents/styled/lib';

export const MenuModalTitle = styled(ModalTitle)`
  margin-bottom: 2rem;
`;
